import { API_AUTH } from "./common";

const GiaoDichChoDuyetApi = {
  list: ({
    sCode,
    sFromDate,
    sToDate,
    sUserName,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `ThuChiGiaoDichChoDuyet/DanhSach?PageIndex=${pageIndex}&PageSize=${pageSize}&sUserName=${sUserName}&sCode=${sCode}&sFromDate=${sFromDate}&sToDate=${sToDate}`,
      {}
    ),
  UpdateStatusGiaoDichChoDuyetByThuChiID: ({ThuChiId}) => API_AUTH.post(`ThuChiGiaoDichChoDuyet/UpdateStatusGiaoDichChoDuyetByThuChiID?ThuChiId=${ThuChiId}`, {}),

};



export default GiaoDichChoDuyetApi;
